module.exports = __webpack_public_path__ + "static/media/noteTakerS.f3cb8e7d.png";